import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LotCodeDropDown } from './lot-code-drop-down.dto';

export class LotCodeDropDownResponse extends GlobalResponseObject{
    data?: LotCodeDropDown[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //LotCodeDropDown
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: LotCodeDropDown[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
